import React from "react";
import { UnstyledButton, Box } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import styles from "./surface.module.css";

interface DashedActionRowProps {
  icon: React.ReactNode;
  label: string;
  actionLabel: string;
  onClick: () => void;
  disabled?: boolean;
  /**
   * Extra content inside the same dashed box, under the row (e.g. Quick add
   * discount chips). The row stays its own button, so children may hold
   * their own interactive elements. Children that render nothing collapse
   * the footer, leaving the plain row.
   */
  children?: React.ReactNode;
}

/**
 * Dashed full-width affordance row per the design, e.g.
 * "No discount applied  [+ Add discount]" / "No tips added  [+ Add tip]".
 */
export default function DashedActionRow({
  icon,
  label,
  actionLabel,
  onClick,
  disabled = false,
  children,
}: DashedActionRowProps) {
  const row = (
    <UnstyledButton
      className={styles.dashedRow}
      onClick={onClick}
      disabled={disabled}
    >
      <Box className={styles.dashedRowIcon}>{icon}</Box>
      <Box component="span" className={styles.dashedRowLabel}>
        {label}
      </Box>
      <Box component="span" className={styles.dashedRowAction}>
        <IconPlus size={13} stroke={2.4} />
        {actionLabel}
      </Box>
    </UnstyledButton>
  );

  if (children === undefined) return row;

  return (
    <Box className={styles.dashedBox}>
      {row}
      <Box className={styles.dashedBoxFooter}>{children}</Box>
    </Box>
  );
}
